import * as React from 'react';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { NewsFeedLabels } from './newsFeedLabels';

type NewsFeedBellButtonProps = {
    unreadCount: number;
    isOpen: boolean;
    labels: Pick<NewsFeedLabels, 'notificationTooltip' | 'notificationTooltipSingular'>;
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

const bellIconSx = { color: '#fff', width: '24px', height: '24px' };

export default function NewsFeedBellButton({
    unreadCount,
    isOpen,
    labels,
    onClick
}: NewsFeedBellButtonProps) {
    const tooltip = `${unreadCount} ${
        unreadCount === 1 ? labels.notificationTooltipSingular : labels.notificationTooltip
    }`;

    return (
        <Tooltip title={tooltip}>
            <IconButton
                aria-label={tooltip}
                onClick={onClick}
                sx={{ padding: 0, width: '24px', height: '24px' }}
            >
                <Badge badgeContent={unreadCount} max={9} color="error" overlap="circular">
                    {isOpen ? (
                        <NotificationsIcon sx={bellIconSx} />
                    ) : (
                        <NotificationsNoneOutlinedIcon sx={bellIconSx} />
                    )}
                </Badge>
            </IconButton>
        </Tooltip>
    );
}
